import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: 'Accueil' },
  { path: '/la-maison', label: 'La Maison' },
  { path: '/collection', label: 'Collections' },
  { path: '/notre-vision', label: 'La Fabrication' },
  { path: '/contact', label: 'Nous Contacter' },
];

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [solidBg, setSolidBg] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';
  const isProduct = location.pathname.startsWith('/collection/');

  useEffect(() => {
    const handleScroll = () => {
      if (isProduct) {
        setSolidBg(false);
        return;
      }
      if (!isHome) {
        setSolidBg(true);
        return;
      }
      const threshold = 3.5 * window.innerHeight - 100;
      setSolidBg(window.scrollY > threshold);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHome, isProduct]);

  const isTransparent = (isHome && !solidBg && !isOpen) || (isProduct && !isOpen);

  const navBg = isTransparent
    ? 'bg-transparent'
    : 'bg-white/95 backdrop-blur-md border-b border-gray-100';

  const linkColor = isTransparent ? 'text-white/70 hover:text-white' : 'text-gray-500 hover:text-gray-900';
  const activeColor = isTransparent ? 'text-white' : 'text-gray-900';

  return (
    <nav className={`fixed top-0 w-full z-50 transition-all duration-500 ${navBg}`}>
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
        <Link to="/" className="transition-opacity duration-300 hover:opacity-70">
          <img
            src="/photos/Logo_fd_transparent.png"
            alt="Pernety"
            className="h-20 w-auto"
            style={{ filter: isTransparent ? 'invert(1) brightness(2)' : 'none' }}
          />
        </Link>

        {/* Desktop */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map(link => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-[11px] tracking-[0.15em] uppercase transition-colors duration-300 ${
                location.pathname === link.path ? activeColor : linkColor
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Mobile burger */}
        <button
          className="md:hidden flex flex-col gap-1.5 z-50"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Menu"
        >
          <span className={`w-6 h-px transition-all duration-300 ${isOpen ? 'rotate-45 translate-y-[3px] bg-gray-800' : (isTransparent ? 'bg-white' : 'bg-gray-800')}`} />
          <span className={`w-6 h-px transition-all duration-300 ${isOpen ? '-rotate-45 -translate-y-[3px] bg-gray-800' : (isTransparent ? 'bg-white' : 'bg-gray-800')}`} />
        </button>
      </div>

      {/* Mobile menu fullscreen */}
      <div className={`md:hidden fixed inset-0 bg-white z-40 flex flex-col items-center justify-center gap-8 transition-all duration-500 ${isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}>
        <img src="/photos/Logo_fd_transparent.png" alt="Pernety" className="h-12 mb-6" />
        {navLinks.map(link => (
          <Link
            key={link.path}
            to={link.path}
            onClick={() => setIsOpen(false)}
            className={`text-sm tracking-[0.2em] uppercase transition-colors ${
              location.pathname === link.path ? 'text-gray-900' : 'text-gray-400 hover:text-gray-900'
            }`}
          >
            {link.label}
          </Link>
        ))}
      </div>
    </nav>
  );
}
